import React, { useCallback, useEffect, useState } from 'react';
import { REC_BET_DATA_MODEL_MAP } from '../../enums/tableNumbers';
import { doChipStore } from '../../store/doChipStore';
import { useRouletteDoBetValidation } from '../../hooks/useRouletteDoBetValidation';
import { STATISTICS_TAB_NAME } from '../../enums/statisticsTabName';
import { gameConfigStore, statisticsStore } from '@pascal/pascal-core/shared/core/store';
import { ApiServices, ApiServiceTypes, useTranslation } from '@pascal/pascal-core';
import { StatisticPageButtons } from './StatisticPageButtons';
import { DiagramsWrapper } from './DiagramsWrapper';
import { PieChartWrapper } from './PieChartWrapper';
import { StatisticNumbersWrapper } from './StatisticNumbersWrapper';
import { observer } from 'mobx-react-lite';
import { gameStore } from '../../store/gameStore';

export const Statistic = observer(({ selectedData, handleMouseMove, handleMouseLeave, setIsShowBetActionModal }) => {
  const { setStatistics, statistics } = statisticsStore;
  const [activeLastRound, setActiveLastRound] = useState(100);
  const { handleDoBetWithValid } = useRouletteDoBetValidation();
  const [tabName, setTabName] = useState(STATISTICS_TAB_NAME.Diagram);
  const { selectedChip } = doChipStore;
  const { gameTypeId } = gameConfigStore;
  const t = useTranslation();
  const { isBetsClosed } = gameStore;

  const getStatistics = useCallback(
    async ({ take, gameTypeId }) => {
      const response = await ApiServices.get(ApiServiceTypes.StatisticsService).getStatistics({ take, gameTypeId });
      const result = response.data.result;
      setStatistics({
        ...statistics,
        [take]: result,
      });
    },
    [statistics]
  );

  useEffect(() => {
    if (!statistics[activeLastRound]) {
      getStatistics({ take: activeLastRound, gameTypeId }).then();
    }
  }, [activeLastRound]);

  const handleDoChip = (e) => {
    const valueType = e.target.getAttribute('data');
    const model = REC_BET_DATA_MODEL_MAP[valueType];
    if (model) {
      const nextChipModel = {
        [model.type]: selectedChip,
        chipType: model.type,
      };
      if (selectedChip) {
        handleDoBetWithValid(nextChipModel);
      }
    }
  };

  return (
    <div className={'statistics-main-wrp'}>
      <div className='statistics-top'>
        <p className='statistics-title'>{t('STATISTICS')}</p>
        <span className='icon-close' onClick={() => setIsShowBetActionModal(false)} />
      </div>
      <StatisticPageButtons tabName={tabName} setTabName={setTabName} />
      {statistics[activeLastRound] && (
        <div
          className={`statistics-mid ${isBetsClosed ? 'pointer-off' : ''}`}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
          onClick={handleDoChip}
        >
          {tabName === STATISTICS_TAB_NAME.Diagram ? (
            <DiagramsWrapper statistics={statistics[activeLastRound]} />
          ) : tabName === STATISTICS_TAB_NAME.PieChart ? (
            <PieChartWrapper statistics={statistics[activeLastRound]} />
          ) : (
            <StatisticNumbersWrapper
              selectedData={selectedData}
              onMouseMove={handleMouseMove}
              onMouseLeave={handleMouseLeave}
              statistics={statistics[activeLastRound]}
            />
          )}
        </div>
      )}
      <div className='statistics-bottom'>
        <div className='last-round-title-box'>
          <p className='last-round-text'>
            {t('LAST')} {activeLastRound} {t('ROUND')}
          </p>
        </div>
        <div className='last-round-box'>
          <div className='last-round-text-box'>
            <span>100</span>
            <span>200</span>
            <span>500</span>
          </div>
          <div className='last-round-inner-box'>
            <div
              onClick={() => {
                setActiveLastRound(100);
              }}
              className={`circle left ${activeLastRound === 100 ? 'active' : ''}`}
            />
            <div
              onClick={() => {
                setActiveLastRound(200);
              }}
              className={`circle center ${activeLastRound === 200 ? 'active' : ''}`}
            />
            <div
              onClick={() => {
                setActiveLastRound(500);
              }}
              className={`circle right ${activeLastRound === 500 ? 'active' : ''}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
});
